import React from "react";
import SelectionItem from "../../SelectionItem";
import Type1 from "./images/child_orthodonty.png";
import Type2 from "./images/basic_orthodonty.png";
import "./index.scss";
import { useTranslation } from "../../../i18n";

const OrthodonticTreatment = ({
  selectStep
}) => {
  const {
    _t
  } = useTranslation();
  const types = [{
    key: "orthoChildTreatment",
    img: Type1,
    name: _t("Детская ортодонтия")
  }, {
    key: "orthoBasicTreatment",
    img: Type2,
    name: _t("Основные методики лечения")
  }];

  function setStep(key) {
    selectStep(key);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "orthodonticTreatment"
  }, /*#__PURE__*/React.createElement("div", {
    className: "orthodonticTreatment-list"
  }, types.map(el => /*#__PURE__*/React.createElement(SelectionItem, {
    key: el.key,
    isSelected: false,
    select: () => {
      setStep(el.key);
    },
    preview: el.img,
    outerTitle: el.name
  }))));
};

export default OrthodonticTreatment;